import {
  CHANGE_FONT_SIZE,
  CHANGE_THEME,
  GET_THEMES,
  SELECT_THEME,
} from "./ConfigActions";

const ConfigReducer = (state, action) => {
  switch (action.type) {
    case CHANGE_FONT_SIZE:
      if (action.payload > 0.5 && action.payload < 1.5) {
        return {
          ...state,
          fontSizeMultiplier: action.payload,
        };
      } else {
        return { ...state };
      }

    case GET_THEMES:
      return {
        ...state,
        themes: action.payload,
      };

    case SELECT_THEME:
      return {
        ...state,
        activeTheme: action.payload,
      };

    case CHANGE_THEME:
      return {
        ...state,
        themeSelected: action.payload,
      };

    default:
      return state;
  }
};

export default ConfigReducer;
